import React, { useState, useEffect } from 'react';
import { Button, Form, Container, Row, Col, Card, Alert, Image } from 'react-bootstrap';
import axios from 'axios';
import { useApi } from './ApiContext';
import './Appcss.css';

const BASE_API_URLS = [
  { label: 'Advance Trauma & Microsurgery Center', url: 'https://nhapi.bpspurnea.com' },
  { label: 'Advance Meternity & Infertility Center', url: 'https://nhapi.bpspurnea.com/amic' },
  { label: 'Orange ICU', url: 'https://nhapi.bpspurnea.com/orange' },
];

const Login = ({ onLogin }) => {
  const { baseUrl, setBaseUrl } = useApi();
  const [userid, setUserid] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [org, setOrg] = useState('RAHMAN MULTISPECIALITY HOSPITAL');

  useEffect(() => {
    // Restore session on mount
    const savedToken = localStorage.getItem('authToken');
    const savedOrg = localStorage.getItem('org');
    const savedBaseUrl = localStorage.getItem('baseUrl');

    if (savedToken && savedBaseUrl) {
      setBaseUrl(savedBaseUrl);
      setOrg(savedOrg || BASE_API_URLS[0].label);
      onLogin(savedToken);
    }

    const selectedApi = BASE_API_URLS.find(api => api.url === baseUrl) || BASE_API_URLS[0];
    setOrg(selectedApi.label);
  }, [baseUrl, setBaseUrl, onLogin]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const selectedApi = BASE_API_URLS.find(api => api.url === baseUrl) || BASE_API_URLS[0];
      const response = await axios.post(`${selectedApi.url}/api/user/login`, {
        userid,
        password,
      });

      if (response.data.token) {
        // Save details in localStorage
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('org', selectedApi.label);
        localStorage.setItem('baseUrl', selectedApi.url);

        setOrg(selectedApi.label);
        onLogin(response.data.token);
      } else {
        setError('Login failed. Please check your credentials.');
      }
    } catch (error) {
      console.error('Error logging in:', error);
      setError(`Login failed. Please try again. ${error.message}`);
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md={6} lg={4}>
          <Card>
            <Card.Body>
              <div className="text-center mb-4">
                <Image src="/images/logos.png" />
                <h3 className="mt-2">Advance Trauma & Multispeciality Hospital</h3>
              </div>
              <Card.Title className="text-center">Login</Card.Title>
              <Form.Group controlId="apiSelect" className="mb-3">
                <Form.Label>Select Organization</Form.Label>
                <Form.Control
                  as="select"
                  value={baseUrl}
                  onChange={(e) => setBaseUrl(e.target.value)}
                >
                  {BASE_API_URLS.map((api) => (
                    <option key={api.url} value={api.url}>{api.label}</option>
                  ))}
                </Form.Control>
              </Form.Group>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleLogin}>
                <Form.Group controlId="userid" className="mb-3">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    type="text"
                    value={userid}
                    onChange={(e) => setUserid(e.target.value)}
                    placeholder="Enter your username"
                    required
                  />
                </Form.Group>
                <Form.Group controlId="password" className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    required
                  />
                </Form.Group>
                <Button variant="primary" type="submit" className="w-100">
                  Login
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
